import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { services } from '../mock';

const Services = () => {
  return (
    <section id="services" className="bg-[#0a0a0a] pt-14 pb-28 lg:pt-20 lg:pb-40 px-6 lg:px-12">
      <div className="max-w-[1500px] mx-auto">
        {/* DM diamond emblem — pre-composed image */}
        <div className="relative w-full max-w-[640px] mx-auto mb-8 md:mb-12 flex items-center justify-center">
          <img
            src="/dm-diamond-emblem.png"
            alt="Dion Magee Events &amp; Weddings emblem on a bed of diamonds"
            className="block w-full h-auto"
            style={{ animation: 'dmFloat 6s ease-in-out infinite' }}
          />
          {/* Soft black blend on all 4 sides for a seamless dissolve into the section */}
          <div className="absolute inset-x-0 top-0 h-[18%] bg-gradient-to-b from-[#0a0a0a] to-transparent pointer-events-none" />
          <div className="absolute inset-x-0 bottom-0 h-[22%] bg-gradient-to-t from-[#0a0a0a] to-transparent pointer-events-none" />
          <div className="absolute inset-y-0 left-0 w-[14%] bg-gradient-to-r from-[#0a0a0a] to-transparent pointer-events-none" />
          <div className="absolute inset-y-0 right-0 w-[14%] bg-gradient-to-l from-[#0a0a0a] to-transparent pointer-events-none" />
        </div>

        {/* Centered title block */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="font-serif text-white text-6xl md:text-7xl lg:text-8xl leading-[1.05]">
            What We
          </h2>
          <h2
            className="font-serif italic text-[#c9a96e] text-6xl md:text-7xl lg:text-8xl leading-[1.05] -mt-2"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
          >
            Deliver
          </h2>
          <div className="flex items-center justify-center gap-4 mt-8">
            <span className="h-px w-10 bg-[#c9a96e]/50" />
            <p className="text-white/70 text-base leading-relaxed max-w-xl">
              Four pillars of excellence that have defined extraordinary events for over 25 years.
            </p>
            <span className="h-px w-10 bg-[#c9a96e]/50" />
          </div>
        </div>

        {/* Service list */}
        <div className="border-t border-white/10">
          {services.map((s) => (
            <div
              key={s.number}
              className="group grid grid-cols-12 gap-6 py-10 lg:py-14 border-b border-white/10 hover:bg-white/[0.02] transition-colors duration-500 px-2 lg:px-4 cursor-pointer"
            >
              <div className="col-span-2 lg:col-span-1 text-white/30 group-hover:text-[#c9a96e] font-serif text-xl tracking-wider transition-colors duration-500">
                {s.number}
              </div>
              <div className="col-span-10 lg:col-span-6">
                <h3 className="font-serif text-white text-3xl md:text-4xl lg:text-[40px] leading-tight">
                  {s.title}
                </h3>
                <p className="text-white/40 text-[10px] tracking-[0.35em] uppercase mt-3">
                  {s.subtitle}
                </p>
                {s.cta && (
                  <Link
                    to="/wedding-planning"
                    className="inline-flex items-center gap-2 text-[#c9a96e] text-[10px] tracking-[0.35em] uppercase mt-5 hover:gap-3 transition-all"
                  >
                    {s.cta}
                    <ArrowRight size={12} />
                  </Link>
                )}
              </div>
              <div className="col-span-12 lg:col-span-4 text-white/70 text-[15px] leading-[1.9] font-light">
                {s.description}
              </div>
              <div className="col-span-12 lg:col-span-1 flex lg:justify-end items-start">
                <div className="w-10 h-10 border border-white/15 group-hover:border-[#c9a96e] group-hover:text-[#c9a96e] text-white/50 flex items-center justify-center transition-all duration-500 group-hover:rotate-45">
                  <ArrowUpRight size={14} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes dmSparkle {
          0%, 100% { opacity: 0.85; transform: rotate(45deg) scale(1); box-shadow: 0 0 12px rgba(255,255,255,0.5); }
          50%      { opacity: 1;    transform: rotate(45deg) scale(1.15); box-shadow: 0 0 24px rgba(255,255,255,0.9); }
        }
        @keyframes dmTwinkle {
          0%, 100% { opacity: 0.4; transform: rotate(45deg) scale(0.9); }
          50%      { opacity: 1;   transform: rotate(45deg) scale(1.4); }
        }
        @keyframes dmFloat {
          0%, 100% { transform: translateY(0); }
          50%      { transform: translateY(-6px); }
        }
      `}</style>
    </section>
  );
};

export default Services;
